import React from 'react';
import { AvatarMarkSC } from './avatar-mark.styled';
import { AVATAR_MARK_ASSETS_MAP, AVATAR_MARK_SIZE_MAP } from './avatar-mark.utils';
import { AvatarMarkProps } from './avatar-marks.types';
import classNames from 'classnames';
import { clsPrefix } from '../../avatar.styled';
import mergeStyleProps from '@lib/utils/styles/mergeStyleProps';

const AvatarMark: React.FunctionComponent<AvatarMarkProps> = ({
  size = 'medium',
  style,
  type,
  variant = 'on-light',
  className,
  ...rest
}) => {
  if (!type) {
    return null;
  }

  const pxSize = AVATAR_MARK_SIZE_MAP[size];
  const iconSize = pxSize - 4;
  const Mark = AVATAR_MARK_ASSETS_MAP[type];

  return (
    <AvatarMarkSC
      style={mergeStyleProps({ width: pxSize, height: pxSize }, style)}
      className={classNames(className, `${clsPrefix}-mark`)}
      {...rest}
    >
      <Mark width={iconSize} height={iconSize} />
    </AvatarMarkSC>
  );
};

export default AvatarMark;
